import { ReactComponent as MetaMap } from "../../clients/RACING/assets/elgiganten/Monza_ELGIGANTEN.svg";
import { ReactComponent as BrandLogo } from "../../assets/elgiganten_logo.svg";

export const ELGIGANTEN_brandVariables = {
  client: "elgiganten-9u2oj", // For picking wich leaderboard to show
  tenantId: "elgiganten-9u2oj", // For picking wich leaderboard to show
  layoutKeyValue: "ELGIGANTEN",
  brand: "elgiganten", // For scss
  gameStyle: "racing", // For picking wich leaderboard to show
  eventCode: "elgiganten_dreamhack_winter_2024", // Needed for fetching correct challenge
  challengeStatus: "ongoing",
  challengeGameType: "f12025",
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  leaderboardLength: 7,
  prize: {
    content: "",
    nameOf: "", // will be marked in color
    typeOfItem: "wireless gaming mouse", // will be added after nameOf
  },
  disclaimer: null,

  content: {
    generalHeadline: "Elgiganten Time Trial",
    generalHeadlineAlt: "Set the fastest time!",
    subHeadline: "Lorem ipsum...",
    overviewHeadline: "Dreamhack winter 2024 winners overview!",
    endscreenHeadline: "Thank you and congratulations to our",
  },

  metaInfo: {
    trackName: "Monza Grand Prix - Italy",
    playerTeamOrCarKey: "",
    playerTeamOrCarValue: "",
    map: MetaMap,
    1: {
      key: "Turns:",
      value: "11",
    },
    2: {
      key: "Length:",
      value: "5.793 km",
    },
    3: {
      key: "Difficulty:",
      value: "very easy",
    },
    4: {
      key: "Record:",
      value: "1:21.046",
    },
  },
};
